import axios from '../axios';

export default {
  getCallLogClient (id, options) {
    const params = {};

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    if (options.append && options.append.length) {
      params.append = options.append.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${id}/call-log-list?` + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
